/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { getObjectSelectedFields } from '@domain/object-selected/object-select.utils';
import { getTagsByType } from '@shared/api/campaign-table-tag-group-api';
import tagsGroupConstants from '@shared/constants/overview/TagsGroupConstants';
import { TOAST_TYPE, showToast } from '@shared/components/messages-and-errors/ToastsNotifications';
import { VIEW_TYPE } from '@shared/constants/dashboard/campaign-table-constants';
import { isDataLoading } from '@shared/axios';
import { SegmentModal } from '@domain/segments/segments-modal/segments-modal';
import { withCampaigns } from '@domain/campaigns';
import { SegmentsModalTitle } from '@domain/segments/segments-modal/components/segments-modal-title';
import {
    calculateFilledTagsPercentage,
    getObjectForAccordion,
} from './segments-modal-container.utils';
import { withSegments } from '../segments.hocs';
import { withSegmentsModal }
    from './segments-modal.hocs';
import { mapObjectSelectedToProps } from '../../_redux/custom-map-state-to-props';

import { TagCampaignSelector } from './tag-campaign-selector/tag-campaign-selector';
import { CAMPAIGN_TABLE_NOTIFICATIONS } from '../segments.constants';
import { getTaggedCampaigns } from '../segments.utils';

const defaultProps = {
    fbTaggedByAdSet: true,
};

interface Props {
    campaigns: any,
    clientId: number,
    editModalSegmentedTaggedCampaign: (object) => void,
    editModalSegmentsRequest: (object) => void,
    isTagsGroupModalOpen: boolean,
    modalSelectedGroup: any,
    selectedObject: any,
    setSelectedGroupBySlug: (object) => void,
    toggleTagsGroupModal: () => void,
}

const SegmentsContainerImpl = ({
    campaigns,
    clientId,
    editModalSegmentedTaggedCampaign,
    editModalSegmentsRequest,
    isTagsGroupModalOpen,
    modalSelectedGroup,
    selectedObject,
    setSelectedGroupBySlug,
    toggleTagsGroupModal,
}: Props) => {
    const taggedCampaigns = getTaggedCampaigns(modalSelectedGroup);

    const handleToggleTagsGroupModal = (groupSlug) => {
        if (isTagsGroupModalOpen && modalSelectedGroup.isCreating) {
            setSelectedGroupBySlug({ groupSlug: groupSlug || VIEW_TYPE.standard });
        }

        toggleTagsGroupModal();
    };

    const [tags, setTags] = useState([]);
    const [loadingTag, setLoadingTag] = useState(true);
    const [saveButtonDisable, setSaveButtonDisable] = useState(false);
    const isLoadingCampaigns = isDataLoading(campaigns.loadState);

    // TODO podemos criar um dominio no redux para tags https://dev.azure.com/paretoio/paretech/_boards/board/t/Squad%20CCR/Backlog%20items/?workitem=15726
    const loadTagList = async () => {
        try {
            const loadedTags = await getTagsByType(tagsGroupConstants.TAGGED_CAMPAIGNS);
            setTags(loadedTags.map(tag => ({ ...tag, value: tag.label })));
            setLoadingTag(false);
        } catch (err) {
            showToast(CAMPAIGN_TABLE_NOTIFICATIONS.LOAD_TAGS_GROUP.ERROR, TOAST_TYPE.ERROR);
            throw err;
        }
    };

    useEffect(() => {
        loadTagList();
    }, []);

    const handleChangeTagGroupModalField = (
        newTag,
        campaign,
        createOption,
    ) => {
        if (createOption) setTags([...tags, { label: newTag, value: newTag }]);
        editModalSegmentedTaggedCampaign({
            campaign, tag: newTag,
        });
    };

    // TODO podemos mover isso para um compoennte?
    // TODO teria de criar um dominio no redux para tag
    const renderTagInputComponent = (props) => {
        // eslint-disable-next-line react/prop-types
        const { style, value } = props;
        return (
            <TagCampaignSelector
                style={style}
                value={value}
                tags={tags}
                loadingTag={loadingTag}
                {...props}
            />
        );
    };


    const handleClickCreateOrUpdateTagsGroup = async () => {
        setSaveButtonDisable(true);
        if (!modalSelectedGroup.name) {
            showToast(CAMPAIGN_TABLE_NOTIFICATIONS.BLANK_NAME_TAGS_GROUP.ERROR,
                TOAST_TYPE.ERROR,
                { delay: 100 });
        } else {
            editModalSegmentsRequest({
                clientId,
                segment: modalSelectedGroup,
                platform: selectedObject.contentTypeName,
            });
            toggleTagsGroupModal();
        }
        setSaveButtonDisable(false);
    };

    const getAccordionData = () => Object.values(getObjectForAccordion(
        Object.values(campaigns.data), taggedCampaigns,
    ));

    const accordionData = getAccordionData();

    const saveButtonHandlersAndData = {
        handleFunction: handleClickCreateOrUpdateTagsGroup,
        isButtonDisable: saveButtonDisable,
    };

    const gaugePercentage = calculateFilledTagsPercentage(
        campaigns, taggedCampaigns,
    );

    return (
        <SegmentModal
            handleToggleTagsGroupModal={handleToggleTagsGroupModal}
            isOpen={isTagsGroupModalOpen}
            isCreating={modalSelectedGroup.isCreating}
            isLoading={saveButtonDisable}
            tagsGroup={accordionData}
            handleChangeTagGroupModalField={handleChangeTagGroupModalField}
            gaugePercentage={gaugePercentage}
            modalHeaderData={() => (<SegmentsModalTitle />)}
            handleClickSaveTags={saveButtonHandlersAndData}
            renderTagInputComponent={renderTagInputComponent}
            isLoadingCampaigns={isLoadingCampaigns}
        />
    );
};

SegmentsContainerImpl.defaultProps = defaultProps;

const mapStateToProps = (state) => {
    const { objectSelected } = mapObjectSelectedToProps(state);
    const {
        isAccount,
        content_type_name: contentTypeName,
    } = getObjectSelectedFields(objectSelected);
    return {
        clientSelected: objectSelected.client_selected,
        clientId: objectSelected.client_selected.id,
        selectedObject: {
            isAccount,
            contentTypeName,
        },
        objectSelected,
    };
};

const enhancers = compose(
    withSegments,
    withSegmentsModal,
    withCampaigns,
    connect(mapStateToProps),
);

export const SegmentsContainer = enhancers(SegmentsContainerImpl);
